import { SetStateAction } from "react";
import { RoomlayoutServiceRow } from "../Domain/Types/FacilityService-Roomlayout-row.types";
import { FileObject } from "../../../../features/FileDropzone/typings/FileObject.type";
import { checkValueTypeLength } from "../../Catering/functions/catering-list.functions";

export function roomlayoutRowValuesToFormData(
  value: Partial<RoomlayoutServiceRow>,
  rowOriginal: RoomlayoutServiceRow,
  userId: string,
  imageFiles: FileObject[]
): FormData {
  const data = new FormData();

  data.append("id", String(value.id));
  data.append("name", String(value.name));
  data.append("description", String(value.description));
  data.append("arrangement", JSON.stringify(value.layout));

  // when add photo - imageFile exists and null rowPic, valPic
  if (imageFiles.length > 0) {
    imageFiles.forEach(({ file }) => {
      data.append("files", file, file.name);
    });
  }

  // Backend: undefined = do not change pictures; [] or array = set picturePaths to that list (removes any not in list).
  // Send picturePaths whenever we intend to set the list (including clear all with [] or null).
  if (value.picturePaths && value.picturePaths.length > 0) {
    data.append("picturePaths", JSON.stringify(value.picturePaths));
  }

  return data;
}

export const checkRoomlayoutVal = (
  value: string,
  item: "name" | "description",
  validationErrors: Record<string, string | undefined>,
  setValidationErrors: (value: SetStateAction<Record<string, string | undefined>>) => void
) => {
  if (value === "") {
    setValidationErrors({
      ...validationErrors,
      [item]: undefined
    });
  } else {
    checkValueTypeLength(value, item, validationErrors, setValidationErrors);
  }
};
